import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#E0E3FF"
      d="M27 6H5a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1"
    />
    <path fill="#697EF5" d="M21 12.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
    <path
      fill="#697EF5"
      fillRule="evenodd"
      d="M27 5H5a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2M5 25v-3.586l6-6 5.581 5.58a1.99 1.99 0 0 0 2.193.435c.242-.1.464-.25.65-.44L22 18.414l5.001 5V25zm18.42-7.995 3.58 3.58V7H5v11.586l4.575-4.575A1.99 1.99 0 0 1 11 13.414a2 2 0 0 1 1.419.591l5.582 5.581 2.574-2.575A1.99 1.99 0 0 1 22 16.414a2 2 0 0 1 1.42.591"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconFileImage = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconFileImage);
export default Memo;
